<script>
  import axios from 'axios'
  import Uploader from '@utils/uploader'

  import {
    generateId,
  } from '../plugins/utils.js'

  export default {
    name: 'FabricUploader',
    components: {
      Uploader
    },
    props: {
      id: {
        type: [String, Number],
        default: (() => generateId()),
      },
      setData: {
        type: Function,
        default: (data, file) => {
          return {
            name: file.name,
            url: data.url,
          }
        }
      },
      acceptedFileTypes:{
        type: String,
        default: '',
      },
      placeholder:{
        type: String,
        default: 'Drag & Drop your files or Browse',
      },
      onlyStore:{
        type: Boolean,
        default: false,
      },
      value: {
        type: [Object, Array],
        default: () => null
      },
      errorMessage: {
        type: String,
        default: 'An error occurred during upload, check that the file is no more than 5MB.',
      },
    },
    data() {
      return {
        files: [],
      }
    },
    methods: {
      tryToUpload(fieldName, file, metadata, load, error, progress, abort, transfer, options) {
        if (! this.onlyStore){
          const formData = new FormData()
          formData.append('file', file, file.name)
          formData.append('type', 'file')
          formData.append('folder', 'product')
          axios
            .post('/files/uploads', formData, {
              onUploadProgress: (progressEvent) => {
                progress(
                  progressEvent.lengthComputable,
                  progressEvent.loaded,
                  progressEvent.total
                )
              },
            })
            .then(({ data }) => {
              if (this.value && Array.isArray(this.value)) {
                this.value.push(this.setData(data, file))
              } else {
                this.setData(data, file)
              }
              this.files = []
              this.$emit('uploadCompleted', file)
              this.$refs.filePond.removeFiles() // programmatically clear
              return load()
            })
            .catch(error)
        } else {
          console.log(this.files)
          this.$emit('storeCompleted', file)
          this.$refs.filePond.removeFiles() // programmatically clear
        }
      },
    },
  }
</script>

<template>
  <section :id="id + '__fb_uploader__'">
    <Uploader
      ref="filePond"
      :server="{
        process: tryToUpload,
      }"
      :label-idle="placeholder"
      :label-file-processing-error="errorMessage"
      :accepted-file-types="acceptedFileTypes"
    />
  </section>
</template>
